import { FlowRouter } from '@dtx-company/inter-app/src/hooks/useFlowRouter'

export function getConversionSource(flowRouter: FlowRouter): string {
  return flowRouter.getString('from') || flowRouter.pathname
}
